/**
 * 클라이언트 사이드에서 쿠키를 가져옵니다.
 * @param name 쿠키 이름
 * @returns 쿠키 값 또는 undefined
 */
export const getCookie = (name: string): string | undefined => {
  if (typeof document === 'undefined') {
    return undefined
  }
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))
  return match ? decodeURIComponent(match[2]) : undefined
}

/**
 * 클라이언트 사이드에서 쿠키를 설정합니다.
 * @param name 쿠키 이름
 * @param value 쿠키 값
 * @param maxAge 만료 시간 (초)
 */
export const setCookie = (name: string, value: string, maxAge: number): void => {
  if (typeof document === 'undefined') {
    return
  }
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}`
}
